import React, { lazy } from 'react';
import { ProtectedRoute } from '@components';

const Detailed = lazy(() => import('./detailed'));

export default {
  path: 'detailed',
  element: <ProtectedRoute title="收支明细" component={<Detailed />} />,
};
